import colors from '../../utils/colors';

export const BORDER_WIDTH = 2;

export const INPUT_RANGE_HEIGHT = 35;
export const INPUT_RANGE_THUMB_SIZE = 31;
export const SLIDER_RIGHT_BG_COLOR = colors.ink20;
